<template>
<div class="home">
    <div style="margin-top:56px;background:linear-gradient(#04b2c5, #9dd2d8) " >
        <div class="container" style="margin-top:0px;padding-top:20px;padding-bottom:40px;">
            <div class="row">
                <div class="col-md-7">
                    <div class="home-title">
                        <div style="font-size:40px">From ZERO To HERO</div>
                        <div style="font-size:20px;margin-top: 10px;">通往编程大门的成功之路</div>
                        
                        <!-- <div style="margin-top:0px">
                            <button class="btn btn-light" @click="jump('/class')" style="margin-right:20px;
                            color:#04b2c5;font-weight:bold">
                                免费试用编程工具</button>

                            <button class="btn btn-light" @click="jump('/resource')" style="color:#04b2c5;font-weight:bold">课程介绍</button>
                        </div> -->
                        <!-- <div style="margin-top: 40px; display: flex;">
                            <img src="https://tsyyapi.dctechonline.cn/static/images/head.jpg" style="width:120px;height:120px;"/>
                            <div style="font-size:20px;margin-left:20px;margin-top:45px;"> 扫描二维码获取 免费试听课链接</div>
                        </div> -->

                        <div style="margin-top:40px;display: flex; justify-content: start;">
                            <button @click="toCenter" v-if="userInfo != null" type="button" class="btn btn-warning home-button" style="margin-right:20px;font-size:14px;">进入学习</button>
                            <button @click="login" v-if="userInfo == null" type="button" class="btn btn-warning home-button" style="margin-right:10px;font-size:14px;">登录学习</button>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <img src="/images/back3.png" style="width:350px;opacity:0.8"/>
                </div>
            
            </div>
        </div>
    </div>
    <div class="container">
        <section id="courses" class="mb-5 py-5" data-v-933e9cdf="">
            <h4 class="text-center mb-5 display-6 fw-bold " data-v-933e9cdf="">课程体系三大支柱</h4><div class="row row-cols-1 row-cols-md-3 g-4" data-v-933e9cdf=""><!-- 学习模块 --><div class="col" data-v-933e9cdf=""><div class="card h-100 border-info" data-v-933e9cdf=""><div class="card-header bg-info text-white fs-5" data-v-933e9cdf="">学 · 深度学习系统</div><div class="card-body" data-v-933e9cdf=""><ul class="list-group list-group-flush" data-v-933e9cdf=""><li class="list-group-item" data-v-933e9cdf="">✅ 一级推进：Java思维，拒绝幼稚化</li><li class="list-group-item" data-v-933e9cdf="">✅ 二级推进：知识网络，解题反射</li><li class="list-group-item" data-v-933e9cdf="">✅ 三级推进：考场重塑，肌肉记忆</li></ul></div></div></div><!-- 练习模块 --><div class="col" data-v-933e9cdf=""><div class="card h-100 border-info" data-v-933e9cdf=""><div class="card-header bg-info text-white fs-5" data-v-933e9cdf="">练 · 多维熔炼系统</div><div class="card-body" data-v-933e9cdf=""><ul class="list-group list-group-flush" data-v-933e9cdf=""><li class="list-group-item" data-v-933e9cdf="">🔥 错误熔炼：Bug锻造，代码免疫</li><li class="list-group-item" data-v-933e9cdf="">🔥 心流熔炼：AI护航，最佳状态</li><li class="list-group-item" data-v-933e9cdf="">🔥 竞技熔炼：开发者对决，突破极限</li></ul></div></div></div><!-- 考试模块 --><div class="col" data-v-933e9cdf=""><div class="card h-100 border-info" data-v-933e9cdf=""><div class="card-header bg-info text-white fs-5" data-v-933e9cdf="">考 · 精准评估系统</div><div class="card-body" data-v-933e9cdf=""><ul class="list-group list-group-flush" data-v-933e9cdf=""><li class="list-group-item" data-v-933e9cdf="">🔍 知识棱镜：精准定位薄弱点</li><li class="list-group-item" data-v-933e9cdf="">🔍 思维棱镜：透视解题策略</li><li class="list-group-item" data-v-933e9cdf="">🔍 行为棱镜：诊断考场习惯</li></ul></div></div></div></div></section>

    </div> 


   

    <div class="container">
        <!-- <div class="row mt-5">
        
        <div class="col-md-7">
          <h3 style="margin:20px 0px">教学师资</h3>
            <p style="text-align: left;">团队教师都是来自于985高校计算机专业毕业的在线编程老师，为孩子提供专业指导和支持，有丰富的教学经验。</p>
            <p style="text-align: left;">首席讲师硕士毕业于上海交通大学，在IT互联网行业深耕多年。</p>
        </div>

        <div class="col-md-5">
          <img src="/images/teach.jpg" class="img-fluid" alt="Processing编程教室">
        </div>
      </div> -->

      <hr/>

      <div class="row" style="margin-top:50px;margin-bottom:50px;">
        <div class="col-md-12">
            <div class="row justify-content-center">
      <!-- 基础启航套餐 -->
      <div class="col-md-4 mb-4">
        <div class="card">
          <div class="card-header">基础启航</div>
          <div class="card-body">
            <!-- <div class="price">¥9,800</div> -->
            <ul class="list-group">
              <li class="list-group-item">1 对 1 精讲</li>
              <li class="list-group-item">基础题库练习</li>
              <li class="list-group-item">3 次模拟考试</li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 强化提高套餐 -->
      <div class="col-md-4 mb-4">
        <div class="card">
          <div class="card-header">强化提高</div>
          <div class="card-body">
            <!-- <div class="price">¥7,800</div> -->
            <ul class="list-group">
              <li class="list-group-item">1 对 1 精讲</li>
              <li class="list-group-item">进阶题库 + 解析</li>
              <li class="list-group-item">3 次模拟考试</li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 考前冲刺套餐 -->
      <div class="col-md-4 mb-4">
        <div class="card">
          <div class="card-header">考前冲刺</div>
          <div class="card-body">
            <!-- <div class="price">¥5,800</div> -->
            <ul class="list-group">
              <li class="list-group-item">1 对 1 练习冲刺</li>
              <li class="list-group-item">在线答疑</li>
              <li class="list-group-item">考前密训</li>
            </ul>
          </div>
        </div>
      </div>
    </div>    
        </div>
        <!-- <div class="col-md-5">
            <h4 style="margin-bottom:20px">我要上课</h4>
            
            <div style="margin-bottom:20px">微信扫描二维码购买课程以及练习</div>
            <div><img src="/images/minicode.jpg" style="max-width:180px"/></div>
        </div> -->
      </div>
    </div>

   
    <div style="height:50px;">&nbsp;</div>
    

    <bottom></bottom>
</div>
  </template>
  
  <script>
  import bottom from '../components/bottom.vue';
  export default {
    name: "HomePage",
    data(){
      return{
        userInfo:{}
      }
    },
    components:{
        bottom
    },
    mounted(){
        var user = localStorage.getItem('user');
        if(user && user != null && user != ''){
            var userObj = JSON.parse(user);
            this.userInfo = userObj;
        }
        else{
          this.userInfo = null;
        }
    },
    methods:{
      login(){
        document.getElementById("login-a").click();
      },
      toCenter(){
        this.$router.push('center');
      },
        jump(url){
            location.href=url;
        },
        sendCode(){

        }
    }
  };
  </script>
  
  <style lang="scss">
  .container {
    margin-top: 30px;
    text-align: center;
  }

  .home{
    img{
        width:100%;
    }

    .section-title{
        font-size:18px;
        font-weight: bold;
        margin-top:30px;
        border:1px solid #cee4f4;
        padding:5px 0px;
        margin-bottom:40px;
        border-radius:5px;
        background:rgb(221, 247, 255);     
    }

    .section-content{
        margin-bottom:30px;
        div{
            height: 30px;
        }
    }

    .home-title
    {
        color:#fff;
        margin-top:80px;
        text-align: left;
        font-size:50px;
        font-weight:bold;
    }

    .home-img{

    }

    .home-button{
        background-color: #fff1c5;
        border-color: #fff1c5;
        color:#6a6131;
        outline: 0;
        height:45px;
        width:100px;
        font-size:16px !important;
    }

    .list-group-flush{
        text-align: left;
    }
  }

  .border-info{
    border-color: #85d4e1 !important;
  }
  .text-white{
    font-weight: bold;
  }
  .bg-info{
    background-color: #85d4e1 !important;
  }

  @media (max-width:800px) {
    .home .home-title{
        font-size:30px;
        text-align: center;
    }

    .home .home-img{
        height:auto !important;
    }

    
  }

  :root {
    --color-85d4e1: #85d4e1;
  }

  .text-85d4e1 { color: var(--color-85d4e1); }
  
 

  .card-horizontal {
    border-radius:3px;
    border: 1px solid var(--color-85d4e1);
    transition: all 0.3s;
    box-shadow: 0 4px 6px rgba(133, 212, 225, 0.1);
  }

  .card-horizontal:hover {
    box-shadow: 0 8px 15px rgba(133, 212, 225, 0.2);
    transform: translateY(-5px);
  }

  .border-top-hover {
    //border-top: 2px solid transparent;
    transition: border-color 0.3s;
  }

  .card-horizontal:hover .border-top-hover {
    border-color: var(--color-85d4e1);
  }

  h4{
    text-align: center;
  }

  li{
    text-align: left
  }

  .card {
      border: none;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      transition: transform 0.3s ease-in-out;
    }

   .card:hover {
      transform: translateY(-10px);
    }

   .card-header {
      background-color: #85d4e1;
      color: white;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
    }

   .card-body {
      padding: 30px;
    }

   .price {
      font-size: 24px;
      font-weight: bold;
      color: #85d4e1;
      text-align: center;
      margin-bottom: 20px;
    }

   .list-group-item {
      border: none;
      padding: 3px 0;
      
      font-weight: normal !important;
    }
  </style>